import * as Joi from "joi";

export const LoginSchema = Joi.object({
  countryCode: Joi.string().required(),
  phone: Joi.string().min(8).max(12).required("Please provide phone number"),
}).options({ abortEarly: false });